import axios from "axios";
import { getEnv } from "../utils";
import { ServerErrorException, ValidationException, TokenInvalidoException, PermissaoException, ClientErrorException } from "./exceptions";
import * as exceptions from "./exceptions";

const api = axios.create({ baseURL: getEnv('VUE_APP_API_BASE_URL') });

api.interceptors.request.use(async config => {
    const token = getAdminToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    let exception;
    let response = error.response;

    if (response) {
        let status = response.status;

        if (status >= 400 || status <= 499) {

            if (status == 401) {
                exception = new TokenInvalidoException();
            } else if (status == 403) {
                exception = new PermissaoException();
            } else {
                var data = response.data;
                if (data.exception) {
                    switch (data.exception) {
                    case "ValidationException":
                        exception = new ValidationException(data.errors, data.errorMessage || data.message || "");
                        break;
                    case "UnexpectedValueException":
                        exception = new ClientErrorException(data.errorMessage || data.message || "");
                        break;
                    default:
                        exception = new exceptions[data.exception](data.errorMessage || null);
                    }
                } else {
                    exception = new ClientErrorException(data.errorMessage || null);
                }
            }

        } else {
            exception = new ServerErrorException(data.errorMessage || null);
        }
    }


    return Promise.reject(exception || error);
});

export default api;

//54.233.253.39
//api.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
//api.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

export const BASES = {
    'sp': {
        label: "Barueri",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
    'ba': {
        label: "Bahia",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
    'es': {
        label: "Espírito Santo",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
    'ex': {
        label: "Extrema",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
    'itajai': {
        label: "Itajaí",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
    'jundiai': {
        label: "Jundiaí",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
    'ma': {
        label: "Maranhão",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
    'sbc': {
        label: "SBC",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
    'contagem': {
        label: "Contagem",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
    'camacari': {
        label: "Camaçari",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
    'rio': {
        label: "Rio de Janeiro",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
    'stg': {
        label: "Staging",
        apiInventaryUrl: 'https://inventario.thorpe.com.br/api',
    },
}

export var ADMIN_TOKEN = "";
export var BASE = "";
export var ID = "";
export var USERNAME = "";
export var PERFIL = "";
export var ROTA_DE_RETORNO = "";
export var ENDERECO_ATUAL = "";
export var ENDERECO_ORIGINAL = "";
export var INVENTARIO_TOKEN = "";
export var MODULO_ATUAL = "";

export function getAdminToken() {
    let token = ADMIN_TOKEN || localStorage.getItem('admin-token');
    return token;
}
export function getInventarioToken() {
    let token = INVENTARIO_TOKEN || localStorage.getItem('inventario-token');
    return token;
}
export function setAdminToken(token) {
    ADMIN_TOKEN = token;
    localStorage.setItem('admin-token', ADMIN_TOKEN);
}
export function setInventarioToken(token) {
    INVENTARIO_TOKEN = token;
    localStorage.setItem('inventario-token', INVENTARIO_TOKEN);
}
export function deleteAdminToken() {
    ADMIN_TOKEN = null;
    localStorage.removeItem('admin-token');
}

export function getBase() {
    let base = BASE || localStorage.getItem('admin-base');
    return base;
}
export function setBase(base) {
    BASE = base;
    localStorage.setItem('admin-base', BASE);
}

export function getModuloAtual() {
    let modulo_atual = MODULO_ATUAL || localStorage.getItem('modulo-atual');
    return modulo_atual;
}
export function setModuloAtual(v) {
    MODULO_ATUAL = v;
    localStorage.setItem('modulo-atual', MODULO_ATUAL);
}

export function getUsername() {
    let username = USERNAME || localStorage.getItem('admin-username');
    return username;
}
export function setUsername(username) {
    USERNAME = username;
    localStorage.setItem('admin-username', USERNAME);
}

export function getUserId() {
    let id = ID || localStorage.getItem('admin-id');
    return id;
}
export function setUserId(id) {
    ID = id;
    localStorage.setItem('admin-id', ID);
}

export function getPerfil() {
    let perfil = PERFIL || localStorage.getItem('perfil');
    return perfil;
}
export function setPerfil(perfil) {
    PERFIL = perfil;
    localStorage.setItem('perfil', PERFIL);
}

export function deleteUsername() {
    USERNAME = null;
    localStorage.removeItem('admin-username');
}

export function getRotaDeRetorno() {
    return ROTA_DE_RETORNO;
}

export function setRotaDeRetorno(rota) {
    if (rota != '/login') {
        ROTA_DE_RETORNO = rota;
    }    
}

export function getEnderecoAtual() {
    let enderecoAtual = ENDERECO_ATUAL || localStorage.getItem('endereco-atual');
    return enderecoAtual;
}
export function setEnderecoAtual(v) {
    ENDERECO_ATUAL = v;
    localStorage.setItem('endereco-atual', ENDERECO_ATUAL);
}
export function deleteEnderecoAtual() {
    ENDERECO_ATUAL = null;
    localStorage.removeItem('endereco-atual');
}

export function getEnderecoOriginal() {
    let enderecoOriginal = ENDERECO_ORIGINAL || localStorage.getItem('endereco-original');
    return enderecoOriginal;
}
export function setEnderecoOriginal(v) {
    ENDERECO_ORIGINAL = v;
    localStorage.setItem('endereco-original', ENDERECO_ORIGINAL);
}
export function deleteEnderecoOriginal() {
    ENDERECO_ORIGINAL = null;
    localStorage.removeItem('endereco-original');
}